import { useQuery } from "@tanstack/react-query";
import type { Book, BrowseResponse } from "@passa-a-pagina/shared";
import { api } from "./api";

export type BrowseSort = "newest" | "oldest" | "title" | "author";

export interface BrowseParams {
  q?: string;
  genre?: string;
  author?: string;
  sort?: BrowseSort;
  page?: number;
  limit?: number;
}

export function useBooks(params: BrowseParams) {
  const search = new URLSearchParams();
  if (params.q) search.set("q", params.q);
  if (params.genre) search.set("genre", params.genre);
  if (params.author) search.set("author", params.author);
  if (params.sort) search.set("sort", params.sort);
  if (params.page) search.set("page", String(params.page));
  if (params.limit) search.set("limit", String(params.limit));
  const qs = search.toString();

  return useQuery({
    queryKey: ["books", "browse", params],
    queryFn: () => api<BrowseResponse>(`/api/books${qs ? `?${qs}` : ""}`),
    placeholderData: (prev) => prev,
  });
}

export function useBook(id: string | undefined) {
  return useQuery({
    queryKey: ["books", "detail", id],
    queryFn: () => api<{ book: Book }>(`/api/books/${id}`),
    enabled: Boolean(id),
  });
}
